import * as React from "react";

function SvgKahuna(props, ref) {
  return (
    <svg
      id="Kahuna_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 118 112"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Kahuna_svg__st0{fill:#4d3f5e}"}</style>
      <path
        className="Kahuna_svg__st0"
        d="M55.9.1C25 .1 0 25.1 0 56s25 55.9 55.9 55.9 55.9-25 55.9-55.9S86.8.1 55.9.1zm0 105.6C28.5 105.7 6.2 83.4 6.2 56S28.5 6.3 55.9 6.3s49.7 22.3 49.7 49.7-22.3 49.7-49.7 49.7z"
      />
      <path
        className="Kahuna_svg__st0"
        d="M88.3 38.2c-9.9-17.9-32.6-24.5-50.5-14.5-5 2.8-9.2 6.6-12.4 11.1-1.8 2.5-3.4 5.3-4.5 8.4-3.1 8.1-3.3 17.2-.5 25.4.2.5 2 4.2 2.8 5.7 4.2 7.6 11 13.6 19.2 16.7.4.1.7.2 1.1.2 1.2 0 2.4-.8 2.9-2 .6-1.6-.2-3.4-1.8-4-6.8-2.6-12.5-7.6-16-13.9-4-7.3-5-15.6-2.7-23.6 1-3.4 2.5-6.5 4.5-9.3 8-11.1 22.9-15.9 36.3-10.8 16 6.1 24 24.1 17.8 40.1-3.1 8-9.1 14.2-16.9 17.5-1.6.7-2.3 2.5-1.6 4 .5 1.2 1.6 1.9 2.8 1.9.4 0 .8-.1 1.2-.2 9.4-4 16.6-11.4 20.3-20.9.2-.6.9-2.3 1-2.6 3-10 2-20.3-3-29.2z"
      />
      <path
        className="Kahuna_svg__st0"
        d="M55.9 74.1c-10 0-18.1-8.1-18.1-18.1 0-1.7 1.4-3.1 3.1-3.1S44 54.3 44 56c0 6.6 5.3 11.9 11.9 11.9S67.8 62.6 67.8 56c0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1 0 10-8.1 18.1-18.1 18.1z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgKahuna);
